if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.addEventListener('click', this.selectImageVariant.bind(this));
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      selectImageVariant(event) {
        const target = event.target.closest('[data-target], [data-media-id]');
        if (!target || !this.contains(target)) return;
        const section = this.closest('.shopify-section');
        const picker = section && section.querySelector('variant-selects, variant-radios');
        if (!picker || typeof picker.getVariantData !== 'function') return;
        if (['/products/marco-island-trivets', '/products/mugs-barry-howe', '/products/soy-candle'].some((url) => picker.dataset.url.endsWith(url))) return;
        const mediaId = (target.dataset.target || target.dataset.mediaId || '').split('-').pop();
        const variants = picker.getVariantData();
        const candidates = variants.filter((variant) => String(variant.featured_media?.id) === mediaId);
        if (!candidates.length) return;
        const selects = Array.from(picker.querySelectorAll('select'));
        const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
        const options = selects.length
          ? selects.map((select) => select.value)
          : fieldsets.map((fieldset) => fieldset.querySelector('input:checked')?.value);
        if (candidates.some((variant) => variant.options.every((value, index) => value === options[index]))) return;
        if (candidates.length !== 1) return;
        const variant = candidates[0];
        if (selects.length === variant.options.length && selects.every((select, index) => Array.from(select.options).some((option) => option.value === variant.options[index]))) {
          selects.forEach((select, index) => { select.value = variant.options[index]; });
        } else if (fieldsets.length === variant.options.length) {
          const inputs = fieldsets.map((fieldset, index) => Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === variant.options[index]));
          if (inputs.some((input) => !input)) return;
          inputs.forEach((input) => { input.checked = true; });
        } else {
          return;
        }
        picker.dispatchEvent(new Event('change', { bubbles: true }));
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
            if (this.elements.thumbnails.slider) this.elements.thumbnails.resetPages();
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}